module.exports = __webpack_public_path__ + "static/media/OpenSans-Light.fa3b86ba.woff2";